import { InspectionInteractionsTimeline } from './inspection-interactions-timeline.component';

interface Step3InteractionsProps {
  policyId: string;
  inspectionId: string;
}

export function Step3Interactions({
  policyId,
  inspectionId,
}: Step3InteractionsProps) {
  return (
    <div className='flex flex-col gap-8 bg-white shadow-xl rounded-2xl py-12 px-8'>
      <InspectionInteractionsTimeline
        policyId={policyId}
        inspectionId={inspectionId}
      />
    </div>
  );
}
